const { listPrograms } = require('./list-programs')

exports.getProgram = async function (state, programId) {
  // We are only getting user programs. If there ever is a need to
  // use this function to get a program that is not in `user.programs`,
  // we can add an `unfiltered` param to the function that can be
  // passed to `listPrograms` to get all programs.
  const programs = await listPrograms(state)
  const program = programs.find(program => program.id === programId)
  if (program) {
    return program
  }

  const error = new Error(`Program with id ${programId} not found`)
  error.status = 404
  throw error
}
